import { toast, Id } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IMAGES } from "../../common/constants";

const commonErr = "OOPS! something went wrong!";

const toastList = new Set();

const MAXIMUM_TOAST = 5;

interface ToastComponentProps {
  message: string;
  subMessage?: string;
}

const ToastComponent: React.FC<ToastComponentProps> = ({
  message,
  subMessage,
}) => (
  <div className="alert-container">
    <p className="alert-message">{message}</p>
    <p className="alert-sub-message">{subMessage}</p>
  </div>
);

export const showAlert = (
  type: number,
  message: string = commonErr,
  subMessage: string = ""
) => {
  if (toast.error === undefined) {
    toast(message, {
      position: "top-left",
      autoClose: 3000,
      draggable: false,
      closeOnClick: true,
    });
  }

  switch (type) {
    case 1: {
      if (toastList.size < MAXIMUM_TOAST) {
        const id: Id = toast.success(
          <ToastComponent message={message} subMessage={subMessage} />,
          {
            icon: <img src={IMAGES.TickAlert} alt="alert" />,
            onClose: () => toastList.delete(id),
          }
        );
        toastList.add(id);
      }
      break;
    }
    case 2: {
      if (toastList.size < MAXIMUM_TOAST) {
        const id: Id = toast.error(
          <ToastComponent message={message} subMessage={subMessage} />,
          {
            icon: <img src={IMAGES.ErrorAlert} alt="alert" />,
            onClose: () => toastList.delete(id),
          }
        );
        toastList.add(id);
      }
      break;
    }
    case 3: {
      if (toastList.size < MAXIMUM_TOAST) {
        const id: Id = toast.info(
          <ToastComponent message={message} subMessage={subMessage} />,
          {
            onClose: () => toastList.delete(id),
          }
        );
        toastList.add(id);
      }
      break;
    }
    default:
  }
};
